import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl text-background-50 hover:text-primary-400 transition-colors">
              久久在线
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              随时随地畅享优质内容。久久在线是您最值得信赖的在线平台，提供海量优质内容资源。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/shipin" className="text-sm text-background-400 hover:text-primary-400 transition-colors">视频</Link></li>
              <li><Link to="/category/zixun" className="text-sm text-background-400 hover:text-primary-400 transition-colors">资讯</Link></li>
              <li><Link to="/category/keji" className="text-sm text-background-400 hover:text-primary-400 transition-colors">科技</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/yule" className="text-sm text-background-400 hover:text-primary-400 transition-colors">娱乐</Link></li>
              <li><Link to="/category/shenghuo" className="text-sm text-background-400 hover:text-primary-400 transition-colors">生活</Link></li>
              <li><Link to="/category/jiaoyu" className="text-sm text-background-400 hover:text-primary-400 transition-colors">教育</Link></li>
              <li><Link to="/category/tiyu" className="text-sm text-background-400 hover:text-primary-400 transition-colors">体育</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 久久在线 版权所有 | 京ICP备2026080801号
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}